/* © 2023 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
export const SERVICE_NAME = 'oidc'
export const ERROR_PREFIX = `promethean.${SERVICE_NAME}`
export const addErrorPrefix = (msg: string) =>
  msg.startsWith(ERROR_PREFIX) ? msg.toLowerCase() : `${ERROR_PREFIX}.${msg.toLowerCase()}`.toLowerCase()

// invalid url config
export const OIDC_INVALID_PROVIDER = 'invalid.provider'
export const OIDC_INVALID_REDIRECT_URI = 'invalid.redirect.uri'
export const OIDC_INVALID_CANCEL_REDIRECT_URI = 'invalid.cancel.redirect.uri'
export const OIDC_INVALID_LOGOUT_URI = 'invalid.logout.uri'
export const OIDC_INVALID_TOKEN_REQUEST = 'invalid.token_request'
export const OIDC_INVALID_OAUTH_REQUEST = 'invalid.request'
export const OIDC_INVALID_SCOPE_REQUEST = 'invalid.scope'
export const OIDC_INVALID_CLIENT_ID = 'invalid.client_id'
export const OIDC_UNAUTHORIZED_CLIENT_ID = 'invalid.unauthorized_client'
export const OIDC_INVALID_URI_ERRORS = [
  OIDC_INVALID_PROVIDER,
  OIDC_INVALID_REDIRECT_URI,
  OIDC_INVALID_CANCEL_REDIRECT_URI,
  OIDC_INVALID_LOGOUT_URI,
  OIDC_INVALID_TOKEN_REQUEST,
  OIDC_INVALID_OAUTH_REQUEST,
  OIDC_INVALID_SCOPE_REQUEST,
  OIDC_INVALID_CLIENT_ID,
  OIDC_UNAUTHORIZED_CLIENT_ID,
]

export const OIDC_ALREADY_LOGGED_IN = 'invalid.already_logged_in'
export const OIDC_NOT_LOGGED_IN = 'invalid.not_logged_in'
export const OIDC_REGISTER_INVALID_CONFIRM_REQUEST = 'invalid.invalid_register_confirm_request'

// static file error
export const INVALID_RESOURCE = 'invalid.resource'

export enum REGISTER_ERROR {
  EMAIL_EXISTS = 'register.email.exists',
  EMAIL_UNCONFIRMED = 'register.email.exists.unconfirmed',
  PASSWORD_STRENGTH = 'register.password.strength',
  REGISTER_ERROR = 'register', //Generic response. We will log the real response so that this can be tracked. This generally should not occur
}

export enum CONFIRM_ERROR {
  EMAIL_ALREADY_CONFIRMED = 'register.confirm.already-confirmed',
  INVALID_CONFIRM_CODE = 'register.confirm.invalid-code',
  INVALID_CONFIRM_EMAIL = 'register.confirm.invalid-email',
  CONFIRM_CODE_EXPIRED = 'register.confirm.expired-code',
  COMMON_REGISTER_CONFIRM_ERROR = 'register.confirm',
}

export enum LOGIN_ERROR {
  PASSWORD_TOO_MANY_REQUESTS = 'password.too_many_requests',
  LOGIN_FAILURE = 'login.failure',
  PASSWORD_MUST_RESET = 'password.reset_required',
}

export enum VERIFICATION_CODE {
  INVALID_A = 'confirm_code.invalid',
  INVALID_B = 'confirm.invalid-code',
}
